import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as XLSX from 'xlsx';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { XlsxService } from 'src/app/services/xlsx/xlsx.service';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {

  temp = {
    retailer: ['col1', 'col2', 'col3'],
    sales: ['col4', 'col5', 'col6']
  }

  roles: any = [];
  selectedRoleIds: any = undefined;
  selectedHeader: any = []
  excelHeaderData: any = {}
  resultData: any = [];
  spaceReplacedData: any = []
  hidden = {
    hideUploadBlock: true,
    hideResultsBlock: true,
  }

  tempOptionModel;
  dynamicHeader: any;
  getUserDetails: any = [];


  fileGroup;
  fileNames: { excel_file_name: string; zip_file_name: string; excel_file: File | null; zip_file: File | null; } = {
    excel_file_name: '',
    zip_file_name: '',
    excel_file: null,
    zip_file: null,
  }
  submitted = false;

  constructor(
    private apiConfig: ApiConfiguration,
    private apiService: ApiService,
    public exportExcelService: ExportExcelService,
    public toast: ToastClientService,
    public modalService: NgbModal,
    private fb: FormBuilder,
    private xls: XlsxService,
    private excelService: ExportExcelService

  ) { }

  ngOnInit() {
    this.getAllUserTypes();
    //  this.getEnrollmentExcelHeaders()

  }




  getAllUserTypes() {
    this.apiService.get(this.apiConfig.getUserType)
      .subscribe((res: any) => {
        if (res.status == 200) {
          this.getUserDetails = res.data;
          this.getUserDetails.data.forEach((item: any) => {
            this.roles.push(item.user_type_name);
          })
        }

      }, err => {

      });
  }

  //  getEnrollmentExcelHeaders() {
  //    this.apiService.get(this.apiConfig.newEnrollmentHeaders)
  //      .subscribe((res: any) => {
  //        this.excelHeaderData = res.data
  //      }, err => {

  //      });
  //  }



  // downloadExcel(targetModal: any) {
  //   if (this.selectedRoleIds == undefined) {
  //     return this.toast.Error('Please Select User role')
  //   } else {
  //     this.tempOptionModel = this.modalService.open(targetModal, {
  //       centered: true,
  //     });
  //   }

  // }

  //  downloadUserExcelSheet() {
  //      const fileUrl = 'assets/UserLoginCredentials.xlsx';
  //       const link = document.createElement('a');
  //       link.href = fileUrl;
  //       link.download = 'UserLoginCredentials.xlsx'; // name for the downloaded file
  //       link.click();
  //  }

  downloadExcelSheet() {
    const headers = ['mobile', 'user_type_name'];
    this.excelService.userProfileExcel(headers, this.roles);
  }


  showFileUploadeModal(targetModal) {

    this.fileGroup = this.fb.group({
      program_id: 1,
      excel_data: new FormControl("", [Validators.required]),
      zip_file: new FormControl("", []),
    });
    this.tempOptionModel = this.modalService.open(targetModal, {
      centered: true,
    });

  }
  showUpdatePassword(e) {
    this.tempOptionModel = this.modalService.open(e, {
      centered: true,
      // backdrop: 'static'
    });


  }

  uploadFiles(event, type) {
    let fileName;
    if (event.target.files.length > 0) {
      let file = event.target.files[0];
      fileName = file.name;

      console.log(fileName, "here is file name")
      if (type == 1) {
        this.fileNames.excel_file_name = fileName
        this.fileNames.excel_file = file
      }
      if (type == 2) {
        this.fileNames.zip_file_name = fileName
        this.fileNames.zip_file = file
      }
    } else {
      this.toast.Error("File has not imported!");
      return
    }
  }

  get g() {
    return this.fileGroup.controls;
  }


  onSubmitUsersfiles() {
    this.submitted = true;

    if (this.fileGroup.invalid) {
      return;
    } else {
      const file = this.fileNames.excel_file;
      if (!(file instanceof File)) {
        console.error("No Excel file selected");
        return;
      }
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        // Read the first sheet
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: '' });
        // const localData = JSON.parse(localStorage.getItem('program'));
        // const program_id = localData.program_id;

        let payload = {
          program_id: 1,
          excel_data: jsonData
        }
        this.apiService.post(this.apiConfig.uploadUserType, payload)
          .subscribe((res) => {
            this.resultData = res.body.data;
            // console.log(this.resultData, "result data");
            this.toast.Success(this.resultData.message);
            this.hidden.hideResultsBlock = false;
            this.hidden.hideUploadBlock = true;
            this.dismissModal();
          });
      };

      reader.readAsArrayBuffer(file);
    }
  }





  downloadRejectedRecords() {
    this.xls.export(this.resultData.failed_records, "Rejected User Records");
  }

  getKeys() {
    return (this.resultData.failed_records && this.resultData.failed_records.length > 0) ? Object.keys(this.resultData.failed_records[0]) : [];
  }


  dismissModal() {
    this.modalService.dismissAll();
    this.submitted = false;
    this.fileNames.excel_file = null;
    this.fileNames.excel_file_name = "";
    this.fileNames.zip_file = null;
    this.fileNames.zip_file_name = "";
  }

}
